import { useEffect, useState } from "react";

export const useFetchUserInfo = (user) => {
  const [userInfo, setUserInfo] = useState([]);
  useEffect(() => {
    if (user.id) {
      setUserInfo([
        { key: "First Name", value: user.firstName },
        { key: "Last Name", value: user.lastName },
        ...(user.email ? [{ key: "Email", value: user.email }] : []),
        { key: "Username", value: user.username },
      ]);
    }
  }, [user]);
  return userInfo;
};
